import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, Zap, CreditCard } from 'lucide-react';
const useCountdown = () => {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 47,
    seconds: 46
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let s = prev.seconds - 1;
        let m = prev.minutes;
        let h = prev.hours;
        if (s < 0) {
          s = 59;
          m -= 1;
        }
        if (m < 0) {
          m = 59;
          h -= 1;
        }
        return {
          hours: h,
          minutes: m,
          seconds: s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return time;
};
const pad = (n: number) => n.toString().padStart(2, '0');
const CountdownBlock = ({
  value,
  label
}: {
  value: string;
  label: string;
}) => <div className="flex flex-col items-center rounded-xl border border-[#A855F7] bg-white px-4 py-3 sm:px-5" data-id="element-63">
    <span className="font-heading text-3xl font-black tabular-nums text-violet-gradient sm:text-4xl" data-id="element-64">
      {value}
    </span>
    <span className="mt-1 text-[10px] font-bold uppercase tracking-wider text-[#1A0A2E]" data-id="element-65">
      {label}
    </span>
  </div>;
const particles = [{
  top: '10%',
  left: '15%',
  size: 12,
  delay: 0,
  color: '#A855F7'
}, {
  top: '25%',
  left: '80%',
  size: 16,
  delay: 0.5,
  color: '#D4A017'
}, {
  top: '50%',
  left: '10%',
  size: 10,
  delay: 1.2,
  color: '#A855F7'
}, {
  top: '65%',
  left: '85%',
  size: 14,
  delay: 0.8,
  color: '#D4A017'
}, {
  top: '85%',
  left: '25%',
  size: 11,
  delay: 1.5,
  color: '#A855F7'
}, {
  top: '80%',
  left: '75%',
  size: 15,
  delay: 0.3,
  color: '#D4A017'
}];
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const handleBuyPro = () => {
    window.location.href = 'https://www.nexorecursos.com/cart/52688340058388:1';
  };
  return <section className="relative w-full overflow-hidden bg-[#1A0A2E] py-16 sm:py-20 md:py-24" data-id="element-66">
      {/* Radial glow */}
      <div className="pointer-events-none absolute inset-0 z-0" data-id="element-67">
        <div className="absolute left-1/2 top-1/2 h-[500px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[rgba(107,33,168,0.40)] blur-[150px]" data-id="element-68" />
      </div>

      {/* Particles */}
      <div className="pointer-events-none absolute inset-0 z-0" data-id="element-69">
        {particles.map((p, i) => <motion.span key={i} className="absolute rounded-full blur-[2px]" style={{
        top: p.top,
        left: p.left,
        width: p.size,
        height: p.size,
        backgroundColor: p.color
      }} animate={{
        y: [0, -20, 0],
        opacity: [0.3, 0.8, 0.3]
      }} transition={{
        duration: 4 + i % 3,
        repeat: Infinity,
        delay: p.delay,
        ease: 'easeInOut'
      }} data-id="element-70" />)}
      </div>

      <div className="relative z-10 mx-auto max-w-[720px] px-5 text-center" data-id="element-71">
        <span className="mb-6 inline-flex items-center rounded-full bg-[#EDE9FF] px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-[#6B21A8]" data-id="element-72">
          NO DEJES PASAR ESTA OPORTUNIDAD
        </span>

        <h2 className="font-heading text-4xl font-bold text-white sm:text-5xl md:text-6xl" data-id="element-73">
          Tu hijo puede empezar
          <br data-id="element-74" />
          <span className="text-violet-gradient" data-id="element-75">a calmarse esta semana.</span>
        </h2>

        <p className="mt-6 text-lg font-medium text-white sm:text-xl" data-id="element-76">
          El sistema está listo. Solo falta vos.
        </p>

        {/* Countdown */}
        <div className="mx-auto mt-10 flex max-w-[400px] items-center justify-center gap-2 sm:gap-3" data-id="element-77">
          <CountdownBlock value={pad(hours)} label="Horas" data-id="element-78" />
          <span className="font-heading text-2xl font-black text-[#D4A017] sm:text-3xl" data-id="element-79">
            :
          </span>
          <CountdownBlock value={pad(minutes)} label="Min" data-id="element-80" />
          <span className="font-heading text-2xl font-black text-[#D4A017] sm:text-3xl" data-id="element-81">
            :
          </span>
          <CountdownBlock value={pad(seconds)} label="Seg" data-id="element-82" />
        </div>

        {/* CTA Button */}
        <div className="mx-auto mt-12 max-w-[560px]" data-id="element-83">
          <motion.button onClick={handleBuyPro} whileHover={{
          y: -2
        }} whileTap={{
          scale: 0.98
        }} animate={{
          boxShadow: ['0 0 30px rgba(212,160,23,0.5)', '0 0 50px rgba(245,200,66,0.7)', '0 0 30px rgba(212,160,23,0.5)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="flex h-[68px] w-full items-center justify-center rounded-[14px] bg-gold-gradient px-6 text-[16px] font-bold uppercase tracking-wide text-[#1A0A2E] sm:text-[20px]" data-id="element-84">
            💥 QUIERO EL KIT COMPLETO AHORA — $27.990
          </motion.button>
        </div>

        {/* Trust Pills */}
        <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-85">
          <span className="flex items-center gap-2 rounded-full border border-[#7C3AED]/30 bg-[#2D1454] px-4 py-2 text-xs text-white" data-id="element-86">
            <Lock size={14} data-id="element-87" /> Pago seguro
          </span>
          <span className="flex items-center gap-2 rounded-full border border-[#7C3AED]/30 bg-[#2D1454] px-4 py-2 text-xs text-white" data-id="element-88">
            <Zap size={14} data-id="element-89" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2 rounded-full border border-[#7C3AED]/30 bg-[#2D1454] px-4 py-2 text-xs text-white" data-id="element-90">
            <ShieldCheck size={14} data-id="element-91" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2 rounded-full border border-[#7C3AED]/30 bg-[#2D1454] px-4 py-2 text-xs text-white" data-id="element-92">
            <CreditCard size={14} data-id="element-93" /> Mercado Pago
          </span>
        </div>

        <p className="mt-8 text-xs text-[#F8F6FF] sm:text-sm" data-id="element-94">
          PDF Digital · Acceso inmediato · Garantía 7 días · Mercado Pago
        </p>
      </div>
    </section>;
};